import { api } from './client';
import type { CharacterDefense, AddDefenseRequest, UpdateDefenseRequest } from '@charbuilder/shared';

export async function addDefense(characterId: string, dto: AddDefenseRequest): Promise<CharacterDefense> {
  const { data } = await api.post(`/characters/${characterId}/defenses`, dto);
  return data;
}

export async function updateDefense(
  characterId: string,
  defenseId: string,
  dto: UpdateDefenseRequest,
): Promise<CharacterDefense> {
  const { data } = await api.patch(`/characters/${characterId}/defenses/${defenseId}`, dto);
  return data;
}

export async function deleteDefense(characterId: string, defenseId: string): Promise<void> {
  await api.delete(`/characters/${characterId}/defenses/${defenseId}`);
}
